import * as helpers from "./helpers";

export class Currency {
    value = 0;
    code = "EUR";

    fromString(value: string) {
        this.value = helpers.currencyStringToNumber(value);
    }

    toString(): string {
        return helpers.numberToCurrencyString(this.value);
    }

    toStringShort(): string | undefined {
        return this.value === 0 ? undefined : helpers.numberToCurrencyStringShort(this.value);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/Currency.ts